import { atom, type WritableAtom } from 'nanostores';
import { Project } from '~/services/versori-api/types';

export type AnonProject = {
  id: string;
  name: string;
  connectorId: never;
  environments: never;
  currentFiles: never;
  createdAt: never;
  settings: never;
  metadata: never;
};

export class ProjectStore {
  project: WritableAtom<Project> = atom<Project>({} as Project);

  setProject(project: Project) {
    this.project.set(project);
  }

  reset() {
    this.project.set({} as Project);
  }
}
